import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { useFormikContext, getIn } from 'formik';

import Field from 'core/components/form/form.v2';
import Divider from 'core/components/divider';
import Label from 'core/components/label/label';

import useStyles from './exclusions.styles';

const OtherStructuresExclusionSection = ({ fieldName, disabled }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext();

  const otherStructuresExclusion = getIn(values, `${fieldName}.otherStructuresExclusion`);

  return (
    <Grid item xs={12}>
      <div className={classes.container}>
        <Grid container>
          <Field
            xs={12}
            type="switch"
            id={`${fieldName}.otherStructuresExclusion`}
            name={`${fieldName}.otherStructuresExclusion`}
            mode="dark"
            label="Other structures exclusion"
            disabled={disabled}
            onChange={(_e, checked) => {
              if (!checked) {
                setFieldValue(`${fieldName}.otherStructuresExclusionDetails`, undefined);
              }
            }}
          />
        </Grid>
        {otherStructuresExclusion && (
          <>
            <Divider className={classes.divider} />
            <Label className={classes.label}>Other structures exclusion</Label>
            <Grid container spacing={2}>
              <Field
                xs={12}
                type="textarea"
                id={`${fieldName}.otherStructuresExclusionDetails`}
                name={`${fieldName}.otherStructuresExclusionDetails`}
                mode="dark"
                label="Description of reason for excluding the selected items (required)"
                rows={3}
                disabled={disabled}
              />
            </Grid>
          </>
        )}
      </div>
    </Grid>
  );
};

OtherStructuresExclusionSection.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

OtherStructuresExclusionSection.defaultProps = {
  disabled: false
};

export default observer(OtherStructuresExclusionSection);
